.badgeContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0rem 0.375rem;
  border-radius: 6px;
  color: var(--sentiment-text-neutral);
  background: var(--sentiment-background-neutral);
}

.shipped {
  background: var(--sentiment-background-info);
  color: var(--sentiment-text-info);
}

.receiving {
  background: var(--sentiment-background-positive);
  color: var(--sentiment-text-positive);
}

.error {
  background: var(--sentiment-background-negative);
  color: var(--sentiment-text-negative);
}